module.exports = __webpack_public_path__ + "img/jameson-age-confirm.cc093b12.png";